import React, { useState } from 'react';
import { Box } from '@mui/material';
import DetailView from './detailView';

const LeadsSection = ({onLeadClick}) => {
  return (
    <Box>
      <DetailView onLeadClick={onLeadClick} />
    </Box>
  );
};
export default LeadsSection;